import { render, staticRenderFns } from "./FooterComponentEdunet.vue?vue&type=template&id=6eaccccb&scoped=true"
import script from "./FooterComponentEdunet.vue?vue&type=script&lang=ts"
export * from "./FooterComponentEdunet.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentEdunet.vue?vue&type=style&index=0&id=6eaccccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaccccb",
  null
  
)

export default component.exports